<template>
	<div class="sms">
		<verify-header></verify-header>
		<vk-mode-layout></vk-mode-layout>
	</div>
</template>

<script>
import VerifyHeader from './VerifyHeader.vue';
import VkModeLayout from './codeLayout.vue';

export default {
  name: 'verify',
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
    VerifyHeader,
    VkModeLayout
  }
}
</script>

<style lang="scss" scoped>
</style>
